<template>
  <ContentPage>
    <template #header>
      <content-page-title>
        Your Leads
      </content-page-title>
    </template>

    <div class="d-flex flex-column" style="height: 100%;"> 
      <SearchBar v-model="search">
        <template #extra_buttons>
          <FilterDialog
            :value="leadsFilters"
            @input="onFilterChange"
          />
        </template>

        <template #results>
          <div v-if="lapsed" class="text-center mt-3 mb-2">
            <strong>
              Referrals PAUSED due to an expired membership<br>
              click <router-link :to="{ name: 'billing/account' }">here</router-link> to Enable
            </strong>
          </div>

          <div v-if="disabled" class="text-center mt-3 mb-2">
            <strong>REFERRALS PAUSED click
              <router-link :to="{ name: 'you/profile' }">here</router-link>
              to Enable
            </strong>
          </div>
          <div class="text-center" style="margin-top: 2px; font-size: 12px">
            <em>{{ leadsFilters.inProgress ? 'Open' : 'All' }} Leads: {{ leads.length }} {{ leadMessage }}</em>
          </div>
        </template>
      </SearchBar>

      <v-list two-line class="rounded-lg mt-2 py-0" style="overflow-y: auto">
        <template v-for="(lead, i) in filteredLeads">
          <v-divider :key="'d-' + i" v-if="i>0" />

          <!-- only one of these is happening   -->
          <ExpiredLead v-if="lead.system_status=='expired'" :lead="lead" :key="'e-' + i"/>
          <DeclinedLead v-else-if="lead.system_status=='declined'" :lead="lead" :key="'e-' + i"/>
          <DisputedLead v-else-if="lead.system_status=='disputed'" :lead="lead" :key="'e-' + i"/>
          <DisqualifiedLead v-else-if="lead.system_status=='disqualified'" :lead="lead" :key="'e-' + i"/>
          <MissedLead v-else-if="lead.system_status=='missed'" :lead="lead" :key="'l-' + i"/>
          <RefundedLead v-else-if="lead.system_status=='refunded'" :lead="lead" :key="'l-' + i"/>
          <SaturatedLead v-else-if="lead.system_status=='saturated'" :lead="lead" :key="'u-' + i"/>
          <UnopenedLead v-else-if="lead.system_status=='unopened'" :lead="lead" :key="'u-' + i"/>
          <ValidLead v-else :lead="lead" :key="'v-' + i"/>
        </template>
      </v-list>
    </div>
  </ContentPage>
</template>

<script>
import { ContentPage, ContentPageTitle } from '@/components/pages'
import FilterDialog from './FilterDialog'
import SearchBar from '@/components/SearchBar'
import LeadComponents from './components'
import { mapActions, mapGetters } from 'vuex'

const normalize = s => s.toLowerCase().trim()

export default {
  name: 'Home',

  components: { 
    ContentPage, ContentPageTitle, 
    FilterDialog, SearchBar,
    ...LeadComponents,
  },

  data: () => ({
    search: '',
  }),

  computed: {
    ...mapGetters('auth', ['me']),
    ...mapGetters('leads', { leads: 'all' }),
    ...mapGetters('filters', ['leadsFilters']),

   lapsed() {
     return !this.me.is_active
   },

    disabled() {
      return !this.lapsed && !this.me.referrals_enabled
    },

    filteredLeads() {
      const term = normalize(this.search)

      if(!term.length) {
        return this.leads
      } else {
        return this.leads.filter( 
          l => normalize(l.service).includes(term) || normalize(l.customer.name).includes(term)
        )
      }
    },

    leadMessage() {
      if (this.leadsFilters?.period)
        return 'in the last ' + this.leadsFilters.period + ' days'
      else
        return  'total'
    },
  },

  methods: {
    ...mapActions('auth', ['loadMe']),
    ...mapActions('leads', ['loadAll']),
    ...mapActions('filters', ['loadLeadsFilters', 'updateLeadsFilters']),

    onFilterChange(newFilters) {
      this.updateLeadsFilters(newFilters)
      this.loadAll(newFilters)
    },
  },

  async created() {
    this.loadMe()

    await this.loadLeadsFilters()
    this.loadAll(this.leadsFilters)
  },
}
</script>